import * as React from "react";
import * as $ from "jquery";
import "datatables.net";
import { CookieManager } from 'src/core/utility/CookieManager';
import {Dimmer, Loader, Segment} from "semantic-ui-react";

interface IProps {
    tableId: string;
    url: string;
    columns: IDataTableColumn[];
    ajaxCustomParameter?: {};
    detailViewHandler: (id: string) => void;
}

interface IState{
    isLoading: boolean;
}

interface IDataTableColumn {
    title: string;
    data: string;
    name: string;
    render?: (data: any, type: any, row: any) => string;
}

export class DataTable extends React.Component<IProps, IState> {

    private dataTable: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: true
        }
    }

    public componentDidMount = () => {
        const self = this;

        this.dataTable = $("#"+this.props.tableId).DataTable({
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": this.props.url,
                "type": "POST",
                "contentType": "application/json",
                "headers": {
                    'authorization': "Bearer " + CookieManager.getSession()
                },
                "data"(data: any) {
                    const additionalValues = [];
                    additionalValues[0] = ((JSON.stringify(self.props.ajaxCustomParameter)) as any);

                    data.AdditionalValues = additionalValues;
                    return JSON.stringify(data);
                }
            },
            "columns": this.props.columns
        });

        this.dataTable.on('draw', () => {
            $(".dt-column-link").on("click",
                (e: any) => {
                    e.preventDefault();
                    const currentEl = $(e.currentTarget);
                    this.props.detailViewHandler(currentEl.data("access"));
                });

            this.setState({
                isLoading: false
            });

        });

    };

    public reloadTable = () => {

        this.setState({
            isLoading: true
        });

        this.dataTable.ajax.reload(() => {
            this.setState({
                isLoading: false
            });
        });

    };

    public resetTable = (customParams?: {}) => {

        this.setState({
            isLoading: true
        });

        this.dataTable.destroy();
        this.dataTable = null;

        this.dataTable = $("#" + this.props.tableId).DataTable({
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": this.props.url,
                "type": "POST",
                "contentType": "application/json",
                "headers": {
                    'authorization': "Bearer " + CookieManager.getSession()
                },
                "data"(data: any) {
                    const additionalValues = [];
                    additionalValues[0] = ((JSON.stringify(customParams)) as any);

                    data.AdditionalValues = additionalValues;
                    return JSON.stringify(data);
                }
            },
            "columns": this.props.columns
        });

        this.dataTable.on('draw', () => {
            $(".dt-column-link").on("click",
                (e: any) => {
                    e.preventDefault();
                    const currentEl = $(e.currentTarget);
                    this.props.detailViewHandler(currentEl.data("access"));
                });

            this.setState({
                isLoading: false
            });

        });
    };

    public render() {

        return (
            <Segment className="table-segment">
                <div className="table-responsive">
                    <Dimmer active={this.state.isLoading} inverted={true}>
                        <Loader inverted={true} inline='centered' />
                    </Dimmer>
                    <table className="ui celled table" id={this.props.tableId}>
                        <thead>
                        <tr>
                            {this.props.columns.map((item, index) =>
                                <th key={index}  />
                            )}
                        </tr>
                        </thead>
                    </table>
                </div>
            </Segment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/common/DataTable.tsx